// extracted by mini-css-extract-plugin
module.exports = {"columnText":"unique-voucher-list_columnText__3BTcS"};